import { Row, Avatar, Skeleton, Col } from "antd";
import { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getCategories } from "~/redux/actions/app";
import BorderedLink from "~/components/app/BorderedLink";
import CategoryMark from "~/components/categories/CategoryMark";

const CategoryNavs = (props) => {
  useEffect(() => {
    props.getCategories();
  }, [props.selected]);

  return (
    <div
      style={{
        backgroundColor: "white",
        // height: "45px",
        display: "flex",
        alignItems: "center",
        padding: "0",
      }}
    >
      <Skeleton
        paragraph={{ rows: 0 }}
        loading={!props.categories}
      >
        <Row
          justify="start"
          gutter={[8, 0]}
          style={{ flex: 1, rowGap: 8 }}
        >
          <Col>
            <BorderedLink
              href="/"
              active={props.selected === "all"}
            >
              全部
            </BorderedLink>
          </Col>
          <Col>
            <BorderedLink
              href="/follows"
              active={props.selected === "follows"}
            >
              我关注的
            </BorderedLink>
          </Col>
          {props.categories &&
            props.categories
              .filter(
                (category) =>
                  !["jobs_channel", "talent"].includes(category.code)
              )
              .map((category) => (
                <Col key={category.id}>
                  <BorderedLink
                    href={
                      category.code === "jd"
                        ? "/jobs-channel"
                        : `/categories/${category.id}`
                    }
                    active={props.selected === category.id}
                  >
                    {category.logo_url && <Avatar src={category.logo_url} />}
                    <span>
                      {category.code === "jd" ? "招聘" : category.name}
                    </span>
                    {category.mark && <CategoryMark mark={category.mark} />}
                  </BorderedLink>
                </Col>
              ))}
        </Row>
      </Skeleton>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCategories,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryNavs);
